import Permissions from '@/security/permissions';
import PermissionChecker from '@/modules/iam/permission-checker';

export class TripPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.tripRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.tripImport,
    );
    this.tripAutocomplete = permissionChecker.match(
      Permissions.values.tripAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.tripCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.tripEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.tripDestroy,
    );
  }
}
